export const FULL_COMPATIBILITY = 'ALL';
export const IGNORE_COMPATIBILITY = 'IGNORE';
export const NO_POS_PROVIDER = 'NO_POS_PROVIDER';
//# sourceMappingURL=constants.js.map